export default __webpack_public_path__ + "static/media/iread4.1da286f4.jpeg";